import { InjectionToken } from '@angular/core';

export * from './variables';
export * from './configuration';
export * from './api/api';

export const ITU_CODE = new InjectionToken<string>('ituCode');
